import { fetchSbLinks } from "@/features/storyblok/lib/api"

export const getArticles = async (path: string) => {
    const links = await fetchSbLinks({ starts_with: path })

    const paths = links
        .filter(({ is_startpage, is_folder }) => !(is_startpage || is_folder))
        .map(({ slug }) => `/${slug}`)

    return {
        paths,
        fallback: true,
    }
}
